import Vue from 'vue';
import Router from 'vue-router';
import index from '@/view/index';
import home from '@/view/home';
import solution from '@/view/solution';
import solution1 from '@/view/solution1';
import solution2 from '@/view/solution2';
import usercase from '@/view/usercase';
import academic from '@/view/academic';
import buycourses from '@/view/buycourses';
import information from '@/view/information';
import informdet from '@/view/informdet';
import payment from '@/view/payment';
import about from '@/view/about';
import login from '@/view/login';
import register from '@/view/register';
import privacy from '@/view/privacy';
import forget from '@/view/forget';
import codepohone from '@/view/codepohone';
import paycomplete from '@/view/paycomplete';
import resetsuccess from '@/view/resetsuccess';
import curriculum from '@/view/curriculum';
import cancelorder from '@/view/cancelorder';
import paynocomplete from '@/view/paynocomplete';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      redirect: '/HomePage',
      children: [
        {
          path: '/HomePage',
          name: 'home',
          component: home,
          meta: {
            // title: '首页'
          },
        },
        {
          path: '/solution',
          name: 'solution',
          component: solution,
          // children: [
          //   {
          //     path: "solution",
          //     name: "solution",
          //     component: solution
          //   },
          //   {
          //     path: "solution1",
          //     name: "solution1",
          //     component: solution1
          //   }
          // ]
        },
        {
          path: '/solution1',
          name: 'solution1',
          component: solution1,
        },
        {
          path: '/solution2',
          name: 'solution2',
          component: solution2,
        },
        {
          path: '/usercase',
          name: 'usercase',
          component: usercase,
        },
        {
          path: '/academic',
          name: 'academic',
          component: academic,
        },
        {
          path: '/buycourses',
          name: 'buycourses',
          component: buycourses,
        },
        {
          path: '/information',
          name: 'information',
          component: information,
        },
        {
          path: '/informdet',
          name: 'informdet',
          component: informdet,
        },
        {
          path: '/payment',
          name: 'payment',
          component: payment,
        },
        {
          path: '/about',
          name: 'about',
          component: about,
        },
        {
          path: '/paycomplete',
          name: 'paycomplete',
          component: paycomplete,
        },
        {
          path: '/curriculum',
          name: 'curriculum',
          component: curriculum,
        },
        {
          path: '/cancelorder',
          name: 'cancelorder',
          component: cancelorder,
        },
        {
          path: '/paynocomplete',
          name: 'paynocomplete',
          component: paynocomplete,
        },
      ],
    },
    {
      path: '/login',
      name: 'login',
      component: login,
    },
    {
      path: '/register',
      name: 'register',
      component: register,
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: privacy,
    },
    {
      path: '/forget',
      name: 'forget',
      component: forget,
    },
    {
      path: '/codepohone',
      name: 'codepohone',
      component: codepohone,
    },
    {
      path: '/resetsuccess',
      name: 'resetsuccess',
      component: resetsuccess,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js